import React, { useEffect, useState, useContext } from 'react';
import AuthorizedRoute from 'commons-ui/src/permission/AuthorizedRoute';

import { useRouteMatch } from 'react-router-dom';
import { Select } from 'baseui/select';
import { AppContext, Loader, ONE_THOUSAND_MILLI_SEC } from 'commons-ui';
import { DASHBOARD_ACTIONS, DASHBOARD_RESOURCES, PAGE_NAMES } from 'constant';
import useService from './utils/useService';
import CountdownTimer from './components/CountdownTimer';
import { Datum } from './models';

function SuperSixComponent() {
	const [matchData, setMatchData] = useState<Datum[]>([]);
	const [selectedMatch, setSelectedMatch] = useState<Datum | null>(null);
	const { showAlert } = useContext(AppContext);
	const { getMatchData: fetchMatchData, matchDataLoading, postMatchSix, postMatchSixLoading, timerRef } = useService();

	useEffect(() => {
		async function getMatchData() {
			const data = await fetchMatchData();
			if (data) {
				setMatchData(data.data?.data ?? []);
			}
		}
		getMatchData();
	}, []);

	const submitSix = async () => {
		if (!selectedMatch?.matchId || !selectedMatch?.matchName || !selectedMatch?.matchType) return;

		try {
			await postMatchSix(selectedMatch?.matchId, selectedMatch?.matchName, selectedMatch?.matchType).then(() => {
				showAlert('Super Six registered successfully!');
			});
		} catch (error) {
			showAlert('An error occurred while registering super six', { type: 'error' });
		}
	};

	if (matchDataLoading) {
		return <Loader />;
	}

	const activeMatches: Datum[] = matchData?.filter((match) => {
		if (!match.startTime || !match.endTime) return false;
		const now = Date.now();
		return now >= match.startTime * ONE_THOUSAND_MILLI_SEC && now <= match.endTime * ONE_THOUSAND_MILLI_SEC;
	});

	const submitDisabled: boolean = !selectedMatch || postMatchSixLoading;

	return (
		<div
			style={{
				display: 'flex',
				flexDirection: 'column',
				alignItems: 'center',
				gap: '24px',
				padding: '32px'
			}}>
			<h3
				style={{
					textAlign: 'center',
					margin: 0,
					fontSize: '18px',
					fontWeight: 500
				}}>
				Super Six Registration
			</h3>
			<div style={{ width: '300px' }}>
				<label
					htmlFor='match-select'
					style={{
						display: 'block',
						marginBottom: '8px',
						fontSize: '14px',
						fontWeight: 500
					}}>
					Select Match
				</label>
				<Select
					id='match-select'
					options={activeMatches?.map((match) => ({
						id: match.matchId,
						label: match.matchName
					}))}
					placeholder='Select a match'
					onChange={({ value }) => {
						const selected = matchData?.find((match) => match.matchId === value[0]?.id);
						setSelectedMatch(selected || null);
					}}
					value={
						selectedMatch
							? [
									{
										id: selectedMatch.matchId,
										label: selectedMatch.matchName
									}
							  ]
							: []
					}
					overrides={{
						ControlContainer: {
							style: () => ({
								backgroundColor: '#ffffff'
							})
						}
					}}
				/>
				{selectedMatch && (
					<div style={{ marginTop: '16px', fontSize: '14px' }}>
						<div style={{ marginBottom: '8px' }}>
							<span style={{ fontWeight: 500 }}>Match ID:</span> {selectedMatch.matchId}
						</div>
						<div>
							<span style={{ fontWeight: 500 }}>Match Type:</span> {selectedMatch.matchType}
						</div>
					</div>
				)}
				{selectedMatch?.startTime && selectedMatch?.endTime && (
					<div style={{ marginTop: '16px', fontSize: '14px' }}>
						<div style={{ marginBottom: '8px' }}>
							<span style={{ fontWeight: 500 }}>Start Time:</span>{' '}
							{new Date(selectedMatch.startTime * ONE_THOUSAND_MILLI_SEC).toLocaleString()}
						</div>
						<div>
							<span style={{ fontWeight: 500 }}>End Time:</span>{' '}
							{new Date(selectedMatch.endTime * ONE_THOUSAND_MILLI_SEC).toLocaleString()}
						</div>
					</div>
				)}
			</div>

			<CountdownTimer ref={timerRef} submitDisabled={submitDisabled} submitSix={submitSix} matchId={selectedMatch?.matchId} />
		</div>
	);
}

const SuperSix: React.FC = () => {
	const { path } = useRouteMatch();

	return (
		<AuthorizedRoute
			exact
			component={SuperSixComponent}
			path={path}
			configPageName={PAGE_NAMES.dashboard}
			configActionName={DASHBOARD_ACTIONS.LIST_SUPER_SIX}
			configResourceName={DASHBOARD_RESOURCES.superSix}
		/>
	);
};

export default SuperSix;
